module.exports = __webpack_public_path__ + "static/media/reject.002d8b00.png";